import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export default function AuthGate({ children }) {
  const authChecked = useSelector((state) => state.auth.authChecked);

  if (!authChecked) {
    return null;
  }

  return children;
}
AuthGate.propTypes = {
  children: PropTypes.node.isRequired,
};
